import axios from 'axios'
import type { AxiosInstance } from 'axios'
import { privateKeyToAccount } from 'viem/accounts'
import { createWalletClient, http } from 'viem'
import { withPaymentInterceptor } from 'x402-axios'
import { getNetworkConfig } from '@/config/networks'

interface PurchaseResponse {
  success: boolean
  purchase_id: string
  item_type: string
  share_id: string
  tx_hash: string
}

/**
 * Create a payment for a marketplace listing using the x402 protocol
 *
 * This function uses x402-axios which automatically:
 * 1. Detects 402 Payment Required responses
 * 2. Creates payment headers using the Coinbase facilitator
 * 3. Retries requests with payment proof
 *
 * No manual payment flow required!
 */
export async function payForListing(
  listingId: string,
  privateKey: string,
  accessToken: string
): Promise<PurchaseResponse> {
  const apiUrl = import.meta.env.VITE_API_URL
  // const purchaseUrl = `${apiUrl}/api/marketplace/purchase/${listingId}`

  // Create a wallet client from the private key
  const networkConfig = getNetworkConfig()
  const account = privateKeyToAccount(privateKey as `0x${string}`)
  const walletClient = createWalletClient({
    account,
    chain: networkConfig.chain,
    transport: http(), // Uses default RPC from chain config
  })

  // Create axios instance with payment interceptor
  // This interceptor automatically handles 402 responses and payment headers
  const baseClient = axios.create({
    baseURL: apiUrl,
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })

  const apiClient = withPaymentInterceptor(baseClient, walletClient as any)
  // Make the purchase request - the interceptor will handle payment automatically!
  const response = await apiClient.get(`/api/marketplace/purchase/${listingId}`)

  return response.data
}
